export default "__VITE_ASSET__BYViioZK__"